import {
  CREATOR_REFERRALS_LOADED,
  CREATOR_REFERRALS_CLEAR,
  CREATOR_REFERRAL_INVITE_LINK_LOADED,
  CREATOR_REFERRAL_INVITE_LINK_CLEAR,
} from '../../actions/actionTypes';

const initialState = {
  referrals: null,
  inviteLink: null,
};

const creatorReferral = (state = initialState, action) => {
  switch (action.type) {
    case CREATOR_REFERRALS_LOADED:
      return { ...state, referrals: action.payload.referrals };

    case CREATOR_REFERRALS_CLEAR:
      return { ...state, referrals: null };

    case CREATOR_REFERRAL_INVITE_LINK_LOADED:
      return { ...state, inviteLink: action.payload.inviteLink };

    case CREATOR_REFERRAL_INVITE_LINK_CLEAR:
      return { ...state, inviteLink: null };

    default:
      return state;
  }
};

export default creatorReferral;
